import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import styled from "styled-components";
import { tableHeaderCellStyles } from "../../styles";

export const HeaderCell = styled(DefaultCellHeader)`
    ${tableHeaderCellStyles}
`;
